export default function Footer() {
  return (
    <footer id="footer" className="bg-background-200/50 border-t border-background-300/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-read-line text-background-50"></i>
              </span>
              <span className="font-heading text-lg text-foreground-900">番茄漫画</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              番茄漫画是一个专注于下拉式竖屏漫画阅读的平台，覆盖韩漫、日漫、国漫三大品类。
              全部免费畅读，支持离线缓存，为千万漫友提供沉浸式阅读体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-300/60 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-100/70 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-300/60 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-100/70 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-300/60 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-100/70 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#media" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">精彩推荐</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">热门榜单</a></li>
              <li><a href="#updates" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">最近更新</a></li>
              <li><a href="#index" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">专题合集</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              <li><a href="#index" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">韩漫精选</a></li>
              <li><a href="#index" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">日漫经典</a></li>
              <li><a href="#index" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">国漫专区</a></li>
              <li><a href="#carousel" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">完结全集</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 番茄漫画. 下拉式漫画阅读，滚动阅读竖屏连续流畅体验。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">隐私政策</a>
            <a href="#contact" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}